import { Link, Route, Routes } from 'react-router-dom';
import '../assets/sass/pages/login/login-1.scss';
import { toAbsoluteUrl } from '../utils/helpers';
// import { ContentRoute } from '../shared/layout';
import Login from './Login';
import { VerificationPage } from './VerificationPage';
import { shallowEqual, useSelector } from 'react-redux';

export function AuthPage() {
    const { isAuthorized } = useSelector(
        ({ auth }: any) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );

    return (
        <div className="d-flex flex-column flex-root">
            <div
                className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                id="kt_login"
            >
                <div
                    className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10 "
                    style={{
                        background: 'gray',
                    }}
                >
                    <div className="d-flex flex-row-fluid flex-column justify-content-between">
                        <Link to="/" className="flex-column-auto mt-5 pb-lg-0 pb-10">
                            <img alt="Logo" className="max-h-70px" src={toAbsoluteUrl('/images/logo.jpeg')} />
                        </Link>

                        <div className="flex-column-fluid d-flex flex-column justify-content-center text-lg-center ">
                            <h3 className="font-size-h1 text-black mb-5">Welcome to Influence vision !</h3>

                            <p className="font-weight-normal text-black opacity-80">
                                Take influencer marketing to a higher level with our visionary influencer marketing
                                platform.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
                    <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                        <Routes>
                            {isAuthorized && <Route path="/verification-page/:id?" element={<VerificationPage />} />}
                            <Route path="/" element={<Login />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </div>
    );
}
